import { IApplicationData } from "./common";
export class PlayAudioData implements IApplicationData {
  constructor() {
    this.audioId = "";
    this.audioName = "";
    this.name = "Play Prompt";
    this.audioPath = "";
    this.sentiment = "normal-speak";
    this.text = "";
    this.content = "";
    this.textChatBot = "";
    this.contentChatBot = "";
    this.option = 1;
    this.allowBreak = false;
    this.log = false;
  }
  audioId: string;
  audioName: string;
  name: string;
  audioPath: string;
  text: string;
  textChatBot: string;
  content: string;
  contentChatBot: string;
  sentiment: string;
  option: number;
  allowBreak: boolean;
  log: boolean;
}
